"use strict";

Shopify.theme.jsFaqSection  = {
  init: function init($section) {
    Shopify.theme.jsFaqSection = $.extend(this, Shopify.theme.getSectionData($section)); // Selectors
	this.$section = $section
    
    let $panel = $section.find('.faq__item')
    let $tags = $section.find('.faq__tags a')

    $tags.on('click',function(e){
      e.preventDefault()
      	let tag = $(this).data('tag')
       $([document.documentElement, document.body]).animate({
         scrollTop: $section.find(`.faq__block-heading#${tag}`).offset().top - 50
      }, 300);
    })
    
    
 	$panel.on('click',function(){
        if($(this).children('.faq__item-answer').css('display')=='none'){
            $(this).addClass('tab--open')
            $(this).children('.faq__item-answer').slideDown()
        }else{
            $(this).children('.faq__item-answer').slideUp(()=>{
                $(this).removeClass('tab--open')
            })
        }
    })
  },
  unload: function unload($section) {
    let $panel = $section.find('.faq__item')
    $panel.off('click');
  }
};